import React from 'react';

export type TrackingContextType = {
    locale: string;
};

export const TrackingContext = React.createContext<TrackingContextType>({
    locale: 'en-US',
});
